module.exports = __webpack_public_path__ + "common/gh-arrow-down-icon-49fada476196e298fb1becbf9de593e3.svg";